import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { useEnvironmentMap } from '@/hooks/admin/environments';
import { useUrlProjectParamsSafe } from '@/hooks/params';
import { UrlEnvironmentType } from '@/typings/url';

/**
 * When linking to any resource via environment, use this hook to determine
 * the target environmentId. This is helpful for resolving cross-project links,
 * staging vs production, etc.
 */
export function useTargetEnvironmentType(
  fallbackEnvironmentType: UrlEnvironmentType = 'production',
) {
  const { accountId } = useDbtCloudAccount();
  const environmentMap = useEnvironmentMap(accountId);
  const currentEnvironmentType = useUrlProjectParamsSafe()?.environmentType;

  return (environmentId: number | 'account') => {
    if (environmentId === 'account') {
      return currentEnvironmentType || fallbackEnvironmentType;
    }
    return (
      environmentMap[environmentId] || currentEnvironmentType || fallbackEnvironmentType
    );
  };
}
